import { CheckoutState } from '../state';
import { getNamespaceValue } from './utils/selector';

export const hasRequiredCannedQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCannedQuestions',
        true,
    );

export const hasRequiredCustomQuestions = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasRequiredCustomQuestions',
        true,
    );

export const isApplePayAvailableAsPaymentMethod = (state: CheckoutState) =>
    getNamespaceValue(
        state.expressCheckout,
        'expressCheckoutConditions.hasApplePay',
        false,
    );
